module.exports = __webpack_public_path__ + "static/media/CBook_Preview.6372ea6f.png";